<div
  [class.notes-selector]="isActive"
  class="block wrapper"
  appTextSize
  gradeLevel="{{ gradeLevel }}"
>
  <ng-container [ngSwitch]="block?.blockType">
    <ng-container *ngSwitchCase="BLOCKTYPES.VideoEmbedBlock">
      <div class="iframe-container" [innerHtml]="videoHtml"></div>
    </ng-container>
    <ng-container *ngSwitchCase="BLOCKTYPES.ImageBlock">
      <ng-container *ngIf="fileLocation; else showPlaceholder">
        <img
          [src]="fileLocation"
          aria-label="Placeholder Image"
          alt="File Location Image"
        />
      </ng-container>
      <ng-template #showPlaceholder>
        <img
          src="assets/img/560x315.png"
          aria-label="Placeholder Image"
          alt="Placeholder Image"
        />
      </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="BLOCKTYPES.KaraokeBlock">
      <app-karaoke-player [karaoke]="karaokePlayer"></app-karaoke-player>
    </ng-container>
    <ng-container *ngSwitchCase="BLOCKTYPES.QuizBlock">
      <app-quiz-block-viewer
        *ngIf="!isStudent"
        [quiz]="quiz"
      ></app-quiz-block-viewer>
      <ng-container *ngIf="isStudent">
        <label *ngIf="isWrong && studentAssignment"
          >Correct Answer is : {{ correctAnswer }}</label
        >
        <label *ngIf="isWrong && !studentAssignment">
          You selected the wrong answer, please try again.
        </label>
        <label *ngIf="isCorrect">You got this correct!</label>
        <div
          [class.point-container]="isFreeAnswerPending"
          [class.points]="!isFreeAnswerPending"
        >
          <label *ngIf="isFreeAnswerPending">Pending teacher's grading</label>
          <app-student-free-response-scoring
            *ngIf="isFreeAnswer"
            [score]="freeResponseScore"
          ></app-student-free-response-scoring>
        </div>
        <app-shared-student-quiz-block
          *ngIf="isStudent"
          [quiz]="quiz"
          [studentAssignment]="studentAssignment"
          [studentId]="studentId"
          [dayBlockId]="block.id"
          [answer]="quizAnswer"
          [unanswered]="unanswered"
          (emitSubmitAnswer)="answerSaved($event)"
          (emitResults)="setResult($event)"
          [class.drag-box]="!unanswered"
          [class.unanswered]="unanswered || isWrong"
          [class.correct]="isCorrect"
          [class.is-pending]="isFreeAnswerPending"
        ></app-shared-student-quiz-block>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="BLOCKTYPES.WYSIWYGBlock">
      <app-wysiwyg-viewer [wysiwyg]="block"></app-wysiwyg-viewer>
    </ng-container>
    <ng-container *ngSwitchCase="BLOCKTYPES.QuizStackBlock">
      <app-quiz-stack-block-viewer
        [block]="block"
      ></app-quiz-stack-block-viewer>
    </ng-container>
    <ng-container *ngSwitchCase="BLOCKTYPES.DocumentBlock">
      <app-document-block-viewer [block]="block"></app-document-block-viewer>
    </ng-container>
  </ng-container>
</div>
